import { IUserSession } from '../../../helpers/user-session'

import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { $Q_SERVICE_NAME, $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { DataTypeGroupService, DATA_TYPE_GROUP_SERVICE_NAME } from '../../../services/data-type-group'

import { DataTypeGroupCreateEditController } from './data-type-group-create-edit.directive.controller'

//#region Asset Imports

import * as TEMPLATE from './data-type-group-create-edit.tpl.html'

//#endregion

// Setup

export class DataTypeGroupCreateEditDirective implements ng.IDirective {
    restrict = 'E'

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        DATA_TYPE_GROUP_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            userSession: IUserSession,
            dataTypeGroupService: DataTypeGroupService,
        ) => new DataTypeGroupCreateEditController(
            $scope,
            $q,
            $timeout,
            userSession,
            dataTypeGroupService,
            DataTypeGroupService.SIMAX_MODULE_NAME
        )]

    template = TEMPLATE
}

// Setup End